/**
 * Default message templates configuration
 * Used as fallback when server data is not available
 */

const defaultTemplates = {
  // Company information
  companyName: '金順興空調工程有限公司',
  companyEmail: 'support@foreverwebs.com',
  companyAddress: '台中市西屯區台灣大道二段910號11樓之5',
  companyTaxId: '00251656',
  contactPerson: '自由揚 Antony Lin',
  lineService: 'https://line.me/R/ti/p/@929bpbpy',
  portfolioUrl: 'https://foreverwebs.com/portfolio/',
  
  // Company image data (base64)
  companyLogoBase64: '',
  companySignatureBase64: '',
  companyStampBase64: '',
  
  // Bank information
  accountName: '金順興空調工程有限公司',
  bankName: '台灣銀行',
  branchName: '台中分行',
  bankCode: '004',
  branchCode: '0031',
  bankAccount: '0000-000-000000',
  
  // Message templates
  quotationNextAction: '確認無誤後請簽名回傳給Line@客服小幫手，若回傳簽名不方便請口頭告知小幫手報價單內容正確，我們就會啟動專案',
  invoicePaymentInstruction: '請於付款期限前完成款項支付，付款完成後請聯繫Line客服以便我們確認款項。如有任何疑問，歡迎隨時聯絡我們。',
  
  // Status display names
  statusPending: '待付款',
  statusPartial: '部分付款',
  statusPaid: '已付款',
  statusOverdue: '已逾期',
  
  // Signature labels
  companySignatureLabel: '金順興空調工程',
  customerSignatureLabel: '客戶簽名',
  
  // Section titles
  remarksSectionTitle: '備註/補充',
  nextActionSectionTitle: '下一步行動',
  paymentInfoSectionTitle: '付款資訊',
  paymentInstructionTitle: '付款說明',
  
  // Last updated
  updatedAt: new Date().toISOString()
};

export default defaultTemplates;
